import { render } from "./expenses-filter.vue?vue&type=template&id=9ae2d56c"
import script from "./expenses-filter.vue?vue&type=script&lang=js"
export * from "./expenses-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__